(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[874],{

/***/ 4184:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 569:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/doc/privacy",
      function () {
        return __webpack_require__(1458);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* reexport */ PolicyContainer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(1953);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Container/Container.js + 2 modules
var Container = __webpack_require__(6336);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/components/common/PolicyContainer/PolicyContainer.module.scss
var PolicyContainer_module = __webpack_require__(2471);
var PolicyContainer_module_default = /*#__PURE__*/__webpack_require__.n(PolicyContainer_module);
;// CONCATENATED MODULE: ./src/components/common/PolicyContainer/PolicyContainer.tsx





var PolicyContainer = function(props) {
    var className = props.className, children = props.children;
    var handleCopy = (0,react.useCallback)(function(e) {
        e.preventDefault();
    }, []);
    (0,react.useLayoutEffect)(function() {
        var listener = function(e) {
            e.preventDefault();
        };
        window.addEventListener("contextmenu", listener);
        return function() {
            return window.removeEventListener("contextmenu", listener);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        className: classnames_default()((PolicyContainer_module_default()).textWrapper, className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            maxWidth: "md",
            sx: {
                margin: "56px auto"
            },
            onCopy: handleCopy,
            children: children
        })
    });
};

;// CONCATENATED MODULE: ./src/components/common/PolicyContainer/index.ts



/***/ }),

/***/ 1458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ privacy; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 32 modules
var esm = __webpack_require__(3683);
// EXTERNAL MODULE: ./src/components/common/PolicyContainer/index.ts + 1 modules
var PolicyContainer = __webpack_require__(2402);
;// CONCATENATED MODULE: ./src/components/Privacy/Privacy.tsx



var Privacy = function() {
    var t = (0,esm/* useTranslation */.$G)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PolicyContainer/* PolicyContainer */.b, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: t("footer.links.privacy")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "INTRODUCTION"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: 'LEAD GATES LTD and its group of companies and affiliates under the "Smart Gates" brand (hereinafter referred to as "Smart Gates" or "we") understand that you are aware of and care about the protection of your personal data, and we take this seriously. This Privacy Policy describes the policies and practices regarding the collection and use of your personal data by us, as well as establishes your rights to privacy. We recognize that that the protection of personal data is an ongoing responsibility and we may update this Privacy Policy from time to time as we apply new methods of processing personal data. We are fully committed to ensuring that our personal data processing practices comply with Art. 13 and Art. 14 of Regulation (EU) 2016/679 of the EP and of the Council of 27 April 2016 on the protection of natural persons with regard to the processing of personal data and on the free movement of such data (General Data Protection Regulation - GDPR).'
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "INFORMATION WE MAY COLLECT FROM YOU"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: "Personal data:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                children: "We may collect and process the following personal data about you:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Information and documentation that you provide to us for registration. Such information may include, but is not limited to, Company name, Company website, Registration number, Registration data, Registered address, Busines address, Phone number, Email, Telegram, WhatsApp."
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Such a record may include your first name, last name, e-mail address, telephone number, company name and other personal data that you may disclose to us during such communication;"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "If you have been granted access to the Client Interface – information about your visits, including but not limited to location data, web logs, other communication data and resources that you access;"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Information about you as a Customer that we receive from other sources, including but not limited to our business partners, service providers and subcontractors."
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: "Other data:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "We may also collect non-personal information about you that does not identify you as a specific person. Such non-personal information we may collect includes:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Browser and device data, such as IP address, operating system and browser type. This is statistical data on the activities and browsing patterns of the Website and does not identify any person;"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Cookie data, such as time spent on the Website, pages visited, language preferences and other anonymous traffic data;"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Company data, such as company name, product and service offerings, jurisdiction."
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "HOW WE USE PERSONAL DATA"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "We use your personal data in order to provide you with our services/products and to enter into contracts and fulfill our contractual obligations accordingly. In this regard, we rely on the contract concluded by you and Smart Gates as a valid basis for processing your personal data."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "We use your personal data to allow you, as a Customer, to use our services/ products. In this regard, we rely on the legitimate interests we pursue."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "We are also required by law to carry out various activities at all times to prevent fraud, money laundering and terrorist financing, as well as to comply with other legal obligations. In this regard, we rely on the need to comply with a legal obligation as a legitimate basis for processing your personal data."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "In addition, we process personal data for the purpose of carrying out various marketing activities and in this regard we rely on your consent as a valid basis for processing your personal data."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Examples of how we may use your personal data include:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "to provide you with information, products or services requested from us;"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "to provide you with information that we believe may be of interest to you, provided that you have consented to be contacted for such purposes;"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "to notify you of changes to our products or services;"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "to ensure that content from the Website is presented in the most effective manner and to ensure the security of our Website;"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "to allow you to use interactive features of our Website;"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "to administer our Website;"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "to verify your identity in order to comply with legal/regulatory requirements;"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "monitor any possible risks of fraud, money laundering, terrorist financing or crime;"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "respond to your inquiries and provide customer support;"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "conduct marketing research and carry out marketing activities."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "HOW LONG WE WILL KEEP YOUR PERSONAL DATA"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "We will retain your personal data for the period necessary to achieve the purposes listed above, unless a longer retention period is required or permitted by law. Please keep in mind that we may be required to retain your personal data for various legal or regulatory reasons, such as to ensure proper processing, settlement, refund or refund for transactions, as well as to investigate any potential fraud and to comply with anti-money laundering and terrorist financing laws and other legal requirements. This means that in the event that you, stop using our services, we will still store certain personal data to comply with our legal obligations."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "USE OF SERVICES BY MINORS"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "The services/products we provide are not intended for persons under the age of sixteen, and we kindly ask such persons not to disclose their personal data to us."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "HOW WE DISCLOSE PERSONAL DATA"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Under certain circumstances, we may disclose the personal data we have collected about you to the following categories of recipients:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "Third Party Financial Institutions."
                                }),
                                " This may include card organizations, payment systems and credit and financial institutions where you maintain your payment account or any other type of account;"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "Credit and reference agencies."
                                }),
                                " We may share personal data with credit reference agencies to conduct credit checks and obtain credit reports;"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "Third Party Service Providers."
                                }),
                                " We disclose personal data to service providers only when it is necessary to ensure the provision of our services."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "Third Parties in Relation to Business Transfers."
                                }),
                                " For example, if we sell a business or assets or merge with another business entity, we may need to disclose personal data to potential business owners or partners."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "Third parties with respect to a legal obligation"
                                }),
                                " or where permitted by law. In certain circumstances, we may be required to disclose or share your personal data with auditors, regulators or law enforcement agencies in order to comply with a legal obligation. We may also disclose personal data, where permitted by law, to enforce or enforce the TERMS OF USE OF THE WEBSITE or other agreements, or to protect our rights, property, customers or others."
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: 'Your personal data may be transferred to and processed at a destination outside the European Economic Area ("EEA"). It may also be processed by personnel working outside the EEA who work for us or one of our service providers. In the event of such a transfer of personal data, we have entered into either Standard Contractual Clauses or other appropriate safeguards to ensure that your personal data is processed in a secure manner and in accordance with this Privacy Policy.'
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "YOUR RIGHTS"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "You have certain rights in relation to how we process your personal data:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                "You have the right to ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "access"
                                }),
                                " your personal data and to receive information about your personal data that we process. You can do this by logging into your customer interface account or by contacting us at the support@smart-gates.net;"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                "You have the right ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "to correct the"
                                }),
                                " information we hold about you if it is inaccurate, and you may do so by logging into your customer interface account or by contacting us at support@smart-gates.net;"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                "You have the right ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "to object to the"
                                }),
                                " processing of your personal data;"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                "You have the right ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "to withdraw your consent"
                                }),
                                " to the processing of your personal data for marketing purposes. We will inform you (prior to the collection of your data) if we intend to use your data for such purposes or if we intend to disclose your information to any third party for such purposes;"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                "You can also ask us to ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "delete"
                                }),
                                " your personal data or stop processing your personal data. However, please note that this right may be subject to certain exceptions. Namely, in situations where we are legally obliged to store your personal data, we will not be able to comply with your request, in which case we will inform you about it;"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                "You may also ask us ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "to provide you with"
                                }),
                                " your personal data or ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "to transfer"
                                }),
                                " ",
                                "it directly to another controller, and we will comply with such a request, provided that the processing of personal data previously carried out by us was based on your consent or was necessary for the performance of the contract and when it is technically feasible;"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                "You have the right ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "to lodge a complaint"
                                }),
                                " with the Information Commissioners if you believe that we have not complied with the requirements of the General Data Protection Regulation in relation to your personal data."
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "COOKIES"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "The Website uses cookies to distinguish you from other Visitors to the Website. This helps to provide you with a good browsing experience and also allows us to improve the Website."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "SECURITY"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "All information provided by you to us is stored on secure servers and we use appropriate organizational, technical and administrative measures to protect your personal data. Once your information is received, we use strict procedures and security features to prevent any unauthorized access."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "However, please note that no transmission of information over the Internet is completely secure, and no storage system is guaranteed to be completely secure. If you have reason to believe that your interaction with us is no longer secure, please contact us immediately."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "CHANGES TO THIS PRIVACY POLICY"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "We may change or update this Privacy Policy. Any changes we may make to this Privacy Policy in the future will be posted on the Website, and any such changes will take effect from the date we post the revised Privacy Policy."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "We may provide you with notices of changes to the Privacy Policy by posting them on our Website."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "CONTACT"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "If you would like to contact us about this Privacy Policy, please use the email address support@smart-gates.net"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Privacy/index.ts


;// CONCATENATED MODULE: ./src/pages/doc/privacy.tsx


var Page = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Privacy, {})
    });
};
var __N_SSG = true;
/* harmony default export */ var privacy = (Page);


/***/ }),

/***/ 2471:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"textWrapper":"PolicyContainer_textWrapper__a77cv"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(569); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);